import { render, staticRenderFns } from "./bigIndex.vue?vue&type=template&id=5441a53a"
import script from "./bigIndex.vue?vue&type=script&lang=js"
export * from "./bigIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports